import * as tslib_1 from "tslib";
var kinds = ['default', 'primary', 'success', 'warning', 'defer', 'close', 'danger', 'icon'];

var BUTTON_KINDS = tslib_1.__spread(kinds, kinds.map(function (k) {
  return k + "-narrow";
}));

export { BUTTON_KINDS };